import React from 'react';
import MileStones from '../../component/milestones';
import XpLevels from '../../component/xplevels';
import Constants from '../../constants';
import DefaultContainer from '../default_container';
import './index_web.css';

const DailyRewardsWeb = () => {
  return (
    <DefaultContainer>
      <div className={`dailyRewardPage__container`} id="dailyrewards">
        <div className="dailyRewardPage__title">DailyRewards</div>
        <div className="dailyRewardPage">
          <XpLevels />
          <div className="dailyRewardPage__earnMoreXpSec">
            <React.Fragment>
              <div className="dailyRewardPage__milestones__header">
                <p className="dailyRewardPage__milestones__header__txt">
                  Earn more <Constants.Svgs.Xp style={{ marginLeft: '5px' }} />
                </p>
                <p className="dailyRewardPage__milestones_header_desc">
                  Play these games to earn more XP points and win more daily rewards!
                </p>
              </div>
              <MileStones />
            </React.Fragment>
          </div>
        </div>
      </div>
    </DefaultContainer>
  );
};

export default DailyRewardsWeb;
